export function CommunitySection() {
  const features = [
    {
      icon: 'ri-group-line',
      title: 'Comunidad Activa 24/7',
      description: 'Conecta con emprendedores que comparten tus mismos objetivos y desafíos'
    },
    {
      icon: 'ri-question-answer-line',
      title: 'Soporte Directo',
      description: 'Obtén respuestas rápidas de mentores y compañeros experimentados'
    },
    {
      icon: 'ri-trophy-line',
      title: 'Retos y Gamificación',
      description: 'Participa en desafíos semanales y gana recompensas por tu progreso'
    },
    {
      icon: 'ri-live-line',
      title: 'Sesiones en Vivo',
      description: 'Clases exclusivas, Q&A y masterclasses con expertos del sector'
    },
    {
      icon: 'ri-share-line',
      title: 'Comparte tus Resultados',
      description: 'Celebra tus victorias y aprende de las experiencias de otros miembros'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <img
          alt=""
          className="w-full h-full object-cover object-center mix-blend-screen"
          src="https://public.readdy.ai/ai/img_res/788e4e68ab777c4ed94bfe1a17826648.jpg"
        />
      </div>
      <div className="absolute top-20 right-20 w-64 h-64 bg-gradient-to-br from-emerald-500 to-cyan-500 rounded-full blur-3xl opacity-20"></div>
      <div className="absolute bottom-20 left-20 w-80 h-80 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full blur-3xl opacity-20"></div>

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-12 space-y-4">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20">
            <i className="ri-community-line text-emerald-400 text-xl"></i>
            <span className="text-white text-sm font-semibold whitespace-nowrap">Comunidad Exclusiva</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-white leading-tight">
            En Nuestra Academia en{' '}
            <span className="bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">Skool</span>
          </h2>
          <p className="text-xl text-white/80 leading-relaxed">
            Únete a una comunidad vibrante donde aprenderás, compartirás y crecerás junto a otros emprendedores digitales
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500">
              <img
                alt="Academia en Skool"
                className="w-full h-auto object-cover object-top"
                src="https://static.readdy.ai/image/35f0715deb3f0b80002922a6d1f4e543/dfe663df6d25069acc2c87f0fcf0980c.png"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-gradient-to-br from-emerald-400 to-cyan-400 rounded-full blur-3xl opacity-60 animate-pulse"></div>
            <div className="absolute -top-6 -left-6 w-40 h-40 bg-gradient-to-br from-purple-400 to-pink-400 rounded-full blur-3xl opacity-40 animate-pulse"></div>
          </div>

          <div className="space-y-6 order-1 lg:order-2">
            <div className="space-y-4">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-r from-emerald-500 to-cyan-500 flex items-center justify-center">
                    <i className={`${feature.icon} text-white text-2xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">{feature.title}</h3>
                    <p className="text-white/70 leading-relaxed">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="pt-6">
              <a
                href="https://chat.whatsapp.com/D1ddDVG4KWTK9K7vPP9RsZ?mode=gi_t"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto px-8 py-4 rounded-xl font-bold text-lg bg-gradient-to-r from-emerald-500 to-cyan-500 text-white hover:shadow-2xl hover:shadow-emerald-500/50 transition-all hover:scale-105 whitespace-nowrap cursor-pointer inline-block text-center"
              >
                Unirme a la Comunidad →
              </a>
            </div>

            <div className="flex flex-wrap gap-6 pt-4">
              <div className="text-center">
                <div className="text-3xl font-bold text-white">500+</div>
                <div className="text-white/60 text-sm whitespace-nowrap">Miembros Activos</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-white">100+</div>
                <div className="text-white/60 text-sm whitespace-nowrap">Posts Diarios</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-white">24/7</div>
                <div className="text-white/60 text-sm whitespace-nowrap">Soporte</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
